import translate from "../../../../../i18n/translate";

export const cieKeys = [
  {
    key: "1723650",
    label: translate("cashPayment.createBallot.cieKeys.simple.label"),
    desc: translate("cashPayment.createBallot.cieKeys.simple.description"),
  },
  {
    key: "1723677",
    label: translate("cashPayment.createBallot.cieKeys.withValidity.label"),
    desc: translate(
      "cashPayment.createBallot.cieKeys.withValidity.description"
    ),
  },
  {
    key: "1723685",
    label: translate("cashPayment.createBallot.cieKeys.custom.label"),
    desc: translate("cashPayment.createBallot.cieKeys.custom.description"),
  },
];
